import resize from "../resize";
import Swiper, {Pagination} from "swiper";
Swiper.use([Pagination]);

const initTeamSlider = () => {
  const slider = document.querySelector(".team__slider");

  const BREAKPOINT = 750;
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        loop: true,
        lazy: true,
        slidesPerView: 1.6,
        spaceBetween: 10,
        pagination: {
          el: ".team .swiper-pagination",
          type: "fraction",
        },
      });
    }
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  const resizeSwiper = () => {
    window.innerWidth <= BREAKPOINT
      ? init()
      : destroy();
  }

  slider && resizeSwiper();
  slider && resize(resizeSwiper);
};

export default initTeamSlider;
